import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureInterception } from './http/interception';
import configureStore, { history } from './store/configureStore.js';
import { initGTM } from './gtm.js';
import AppWithFlagsSupport from './features/App/AppWithFlagsSupport';
import * as serviceWorker from './serviceWorker';
import './fonts/stylesheet.css';
import './styles/index.scss';
import { ConnectedRouter } from 'connected-react-router';
import ScrollTo from './routing/ScrollTo';
import { StylesProvider, createTheme, MuiThemeProvider } from '@material-ui/core/styles';

const store = configureStore({});
configureInterception({ dispatch: store.dispatch });

// Replaced react-gtm-module with manual GTM initialization.
// This avoids the inline GTM snippet blocked by CSP while preserving the original GTM behavior.
if (process.env.NODE_ENV === 'production') {
    initGTM(process.env.REACT_APP_GTM_CONTAINER_ID);
}

const theme = createTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true, // Disable ripple for all components that use ButtonBase
        },
    },
});

const rootElement = document.getElementById('root');
const APP = (<StylesProvider injectFirst>
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <ScrollTo />
                <AppWithFlagsSupport />
            </ConnectedRouter>
        </Provider>
    </MuiThemeProvider>
</StylesProvider>);
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(APP, rootElement);
} else {
    ReactDOM.render(APP, rootElement);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
